export default __webpack_public_path__ + "static/4-check-value-name-a9e6823cdc40875bf63619a10e5e3707.png";